import { identity } from 'lodash-es';
import { API_BASEURL } from 'config';
import { returnVoid } from 'services/ServiceFactory';
import ServiceFactory from 'services/ServiceFactory/ServiceFactory';
import { RECEIVE_BEACON_EVENT_PATH } from './constants';
import { BeaconEvent } from './types';

const serviceFactory = new ServiceFactory(API_BASEURL);

export const sendBeaconEvent = serviceFactory.createPostEndpoint(
  RECEIVE_BEACON_EVENT_PATH,
)({
  data: identity<BeaconEvent>,
  select: returnVoid(),
});
